function u(r, o, t) {
  const c = [];
  t = t * Math.PI / 180;
  for (const s of r) {
    const n = s[0] - o[0], h = s[2] - o[2], f = o[0] + (n * Math.cos(t) - h * Math.sin(t)), M = s[1], d = o[2] + (n * Math.sin(t) + h * Math.cos(t));
    c.push([f, M, d]);
  }
  return c;
}
export {
  u as rotateAroundY
};
//# sourceMappingURL=index23.js.map
